export default __webpack_public_path__ + "static/equilibre_icon_services-6ffedb11c3f4d24f54ea3f7dbdf5e255.png";